import {queryIncuBaseList} from '@api/incubator/base';
import localDb from '@util/localDb';

// 孵化器列表
const INCUBATOR_LIST = 'INCUBATOR_LIST';

export function getIncuBaseList() {
  return dispatch => {
    return queryIncuBaseList().then(res => {
      localDb.set(INCUBATOR_LIST, res.data);
      if (res.statusCode === 200) {
        return dispatch({
          type: INCUBATOR_LIST,
          data: res.data,
        });
      }
    });
  };
}

export function incubatorList(state = [], action) {
  switch (action.type) {
    case INCUBATOR_LIST:
      return action.data;
    default:
      return localDb.get(INCUBATOR_LIST);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/incubator_list.js